export const VIDFLEET_POWER_LOST_REQUEST = "VIDFLEET_POWER_LOST_REQUEST";
export const VIDFLEET_POWER_LOST_RESULT = "VIDFLEET_POWER_LOST_RESULT"; 